import { Environment } from './environment.model';

declare function require(moduleName: string): { version: string };

export const environment: Environment = {
    company: {
        entityName: 'Telit IoT Solutions, Inc.',
        entityRegisteredName: 'Telit IoT Solutions, Inc.'
    },
    defaultSourcePrefix: "dev-us",
    instances: {
        "cust-cu" : {
            "appCenter": "https://portal-engr.telit.com",
            "defaultDeviceTypes": {
                "SGP22_MULTI_NEXT_MVNO": "SGP22_PreloadedMVNO",
                "SGP22_MVNO_PROFILE": "SGP22_eProfile"
            },
            "endpoint": "device1-api.10646.cn/api",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json",
            "key": "cust-cu",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "name": "China Unicom",
            "switchGroup": "cu",
            "toesApi": "https://toes-engr.devicewise.net/private"
        },
        "cust-swisscom" : {
            "appCenter": "https://portal-engr.telit.com",
            "defaultDeviceTypes": {
                "SGP22_MULTI_NEXT_MVNO": "SGP22_PreloadedMVNO",
                "SGP22_MVNO_PROFILE": "SGP22_eProfile"
            },
            "endpoint": "api.iotcloud.swisscom.com/api",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json",
            "key": "cust-swisscom",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "name": "Swisscom",
            "switchGroup": "swisscom",
            "toesApi": "https://toes-engr.devicewise.net/private"
        },
        "cust-swisscom-test" : {
            "appCenter": "https://portal-engr.telit.com",
            "defaultDeviceTypes": {
                "SGP22_MULTI_NEXT_MVNO": "SGP22_PreloadedMVNO",
                "SGP22_MVNO_PROFILE": "SGP22_eProfile"
            },
            "endpoint": "api-test.iotcloud.swisscom.com/api",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json",
            "key": "cust-swisscom-test",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "name": "Swisscom (Test)",
            "switchGroup": "swisscom",
            "toesApi": "https://toes-engr.devicewise.net/private"
        },
        "dev-us" : {
            "appCenter": "https://appcenter.telit.com",
            "defaultDeviceTypes": {
                "SGP22_MULTI_NEXT_MVNO": "SGP22_PreloadedMVNO",
                "SGP22_MVNO_PROFILE": "SGP22_eProfile"
            },
            "endpoint": "api-dev.devicewise.com/api",
            "instancesUrl": "https://appcenter.telit.com/common/instances.json",
            "key": "dev-us",
            "lnfUrl": "https://appcenter.telit.com/common/appcenter.telit.com.json",
            "name": "Developer-US",
            "switchGroup": "prod",
            "telitIccidPrefix": "89358",
            "toesApi": "https://toes-dev.devicewise.net/private"
        },
        "engr-us" : {
            "appCenter": "https://portal-engr.telit.com",
            "defaultDeviceTypes": {
                "SGP22_MULTI_NEXT_MVNO": "SGP22_Preloaded_Profile",
                "SGP22_MVNO_PROFILE": "SGP22_eProfile"
            },
            "endpoint": "engr-api.devicewise.com/api",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json",
            "key": "engr-us",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "name": "Engineering-US",
            "switchGroup": "engr",
            "telitIccidPrefix": "89589",
            "toesApi": "https://toes-engr.devicewise.net/private"
        },
        "prod-de" : {
            "appCenter": "https://appcenter.telit.com",
            "defaultDeviceTypes": {
                "SGP22_MULTI_NEXT_MVNO": "SGP22_PreloadedMVNO",
                "SGP22_MVNO_PROFILE": "SGP22_eProfile"
            },
            "endpoint": "api-de.devicewise.com/api",
            "instancesUrl": "https://appcenter.telit.com/common/instances.json",
            "key": "prod-de",
            "lnfUrl": "https://appcenter.telit.com/common/appcenter.telit.com.json",
            "name": "Production-DE",
            "switchGroup": "prod",
            "telitIccidPrefix": "89358",
            "toesApi": "https://toes-prod.devicewise.net/private"
        },
        "prod-us" : {
            "appCenter": "https://appcenter.telit.com",
            "defaultDeviceTypes": {
                "SGP22_MULTI_NEXT_MVNO": "SGP22_PreloadedMVNO",
                "SGP22_MVNO_PROFILE": "SGP22_eProfile"
            },
            "endpoint": "api-us.devicewise.com/api",
            "instancesUrl": "https://appcenter.telit.com/common/instances.json",
            "key": "prod-us",
            "lnfUrl": "https://appcenter.telit.com/common/appcenter.telit.com.json",
            "name": "Production-US",
            "switchGroup": "prod",
            "telitIccidPrefix": "89358",
            "toesApi": "https://toes-prod.devicewise.net/private"
        },
        "stage-us" : {
            "appCenter": "https://portal-engr.telit.com",
            "defaultDeviceTypes": {
                "SGP22_MULTI_NEXT_MVNO": "SGP22_PreloadedMVNO",
                "SGP22_MVNO_PROFILE": "SGP22_eProfile"
            },
            "endpoint": "stage-api.devicewise.com/api",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json",
            "key": "stage-us",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "name": "Stage-US",
            "switchGroup": "stage",
            "telitIccidPrefix": "89589",
            "toesApi": "https://toes-engr.devicewise.net/private"
        }
    },
    production: true,
    useMock: false,
    version: require("../../package.json").version
};

export const defaultAppCenterUrl = "https://portal-engr.telit.com";
export const maxNumberOfIccidsInRecruiter = 2000;
export const defaultDwopenEndpoint = "https://engr-api.devicewise.com/api";
export const unassignOrgId = "6f53c230-1cfa-11eb-adc1-000000000000";
